import { useState, useEffect } from 'react';

const Gifts = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      <div className="min-h-screen bg-[#EFEAE7] flex items-center">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center">
            {/* Left side - Images */}
            <div className="relative w-full md:w-[90%]">
              <img 
                src="/saigon.png"
                alt="Large gift box" 
                className="w-full rounded-lg"
              />
              <img 
                src="/chua1cot.png"
                alt="Small gift box" 
                className="absolute bottom-0 right-0 w-2/3 translate-x-1/3 translate-y-1/4 rounded-lg"
              />
            </div>

            {/* Right side - Content */}
            <div className="flex flex-col gap-6 md:pl-8">
              <h1 className="font-['Playfair_Display_SC'] text-4xl md:text-5xl font-bold text-[#2E492A]">
                GIFTS
              </h1>
              <p className="font-['Outfit'] text-base md:text-lg leading-relaxed text-gray-700">
                Lotus Story offers a relaxed yet refined dining experience, catering to guests who appreciate both 
                authenticity and innovation. Our casual tasting menus allow diners to explore a variety of flavors in a 
                comfortable setting, making each visit a unique gastronomic adventure.
              </p>
              <a 
                href="https://app.gift-it.com.au/buy/lotustoryrestaurant"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#2E492A] text-white px-8 py-3 rounded-lg font-['Outfit'] hover:bg-[#2E492A]/80 transition-colors w-full md:w-auto text-center"
              >
                Check Out
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gifts; 